import { pathOr } from 'ramda';
import { createSelector } from 'reselect';
import {
  SET_INITIAL_LIVE_DATA,
  SET_LIVE_DATA,
} from '../../../../constants/centrifugo';
import { PROJECTS } from '../../../../../constants/centrifugo';

const initialState = {
  data: {},
};

export const liveDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LIVE_DATA:
      const { gameId, ...data } = action.payload;
      return {
        data: {
          ...state.data,
          [gameId]: {
            ...state.data[gameId],
            ...data,
          },
        },
      };

    case SET_INITIAL_LIVE_DATA: {
      return {
        data: {
          ...state.data,
          ...action.payload,
        },
      };
    }
    default: {
      return state;
    }
  }
};

export const liveDataObjSelector = (state) =>
  pathOr(initialState, ['domain', 'centrifugo', PROJECTS.LIVE_DATA], state);

export const liveDataSelector = createSelector(liveDataObjSelector, (state) =>
  pathOr(initialState.data, ['data'], state)
);
